import { Tenant } from '../types/tenant';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api';

type ConLogo = Pick<Tenant, 'id' | 'logoBlob' | 'logoDarkBlob'>;

/**
 * Link al logo della scuola, servito senza login da /public/tenants/:id/logo.
 * Il nome del blob cambia a ogni caricamento e fa da versione: con il link
 * nuovo il browser non mostra il logo vecchio dalla cache.
 */
export const tenantLogoUrl = (tenant: ConLogo | null | undefined, variant: 'light' | 'dark' = 'light'): string | null => {
  if (!tenant) return null;
  const blob = variant === 'dark' ? tenant.logoDarkBlob : tenant.logoBlob;
  return blob ? `${API_BASE}/public/tenants/${tenant.id}/logo/${variant}?v=${encodeURIComponent(blob.slice(-12))}` : null;
};

/**
 * Il logo da mostrare su un fondo chiaro o scuro.
 * Sul fondo scuro, senza la variante apposta, si usa il principale dentro un
 * riquadro chiaro (`riquadro`): un logo scuro sul nero sparirebbe.
 */
export const logoPerSfondo = (tenant: ConLogo | null | undefined, scuro: boolean): { src: string; riquadro: boolean } | null => {
  if (scuro) {
    const dark = tenantLogoUrl(tenant, 'dark');
    if (dark) return { src: dark, riquadro: false };
    const light = tenantLogoUrl(tenant, 'light');
    return light ? { src: light, riquadro: true } : null;
  }
  const light = tenantLogoUrl(tenant, 'light');
  return light ? { src: light, riquadro: false } : null;
};
